export default function HeroSection() {
  return (
    <section
      className="min-h-screen flex flex-col items-center justify-center px-[60px] pt-[120px] pb-[80px] relative overflow-hidden bg-[#060606] max-md:px-6"
      style={{ fontFamily: "'Work Sans', sans-serif" }}
    >
      {/* Radial crimson glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse 60% 50% at 50% 60%, rgba(172,18,28,0.06), transparent 70%)',
        }}
      />
      {/* Center vertical crimson line */}
      <div
        className="absolute top-0 left-1/2 w-[2px] h-full pointer-events-none"
        style={{
          background:
            'linear-gradient(to bottom, transparent, #ac1218 20%, #ac1218 80%, transparent)',
          opacity: 0.6,
        }}
      />

      <p className="text-[11px] font-bold tracking-[0.22em] text-[#d43742] uppercase mb-8 relative z-10">
        Jessica AI — Your Delegate
      </p>

      <p
        className="font-bold text-[#e0dbd5] text-center leading-[1.1] mb-2 relative z-10 tracking-[0.02em]"
        style={{
          fontFamily: "'Big Shoulders Display', sans-serif",
          fontSize: 'clamp(28px, 4vw, 52px)',
        }}
      >
        You can&apos;t be in two places at once.
      </p>

      <h1
        className="font-black text-[#faf9f7] text-center leading-[0.9] relative z-10 tracking-[-0.01em] mb-10"
        style={{
          fontFamily: "'Big Shoulders Display', sans-serif",
          fontSize: 'clamp(72px, 12vw, 148px)',
        }}
      >
        She can.
      </h1>

      <p className="text-[13px] font-normal text-[#ccc7c2] text-center max-w-[560px] leading-[1.5] relative z-10 mb-[52px]">
        Jessica joins your meetings on your behalf, represents you in the room,
        keeps you in the loop in real time, and brings you in only when you actually need to be there.
      </p>

      <a
        href="#waitlist"
        className="inline-block px-[44px] py-[16px] bg-[#ac1218] text-[#faf9f7] text-[13px] font-bold tracking-[0.14em] uppercase no-underline cursor-pointer transition-all duration-200 hover:bg-[#d43742] hover:-translate-y-[1px] relative z-10 whitespace-nowrap"
      >
        Join the Beta Waitlist
      </a>

      <p className="mt-4 text-[11px] text-[#b8b2ac] relative z-10 tracking-[0.06em]">
        Building now &nbsp;·&nbsp; Beta opening soon &nbsp;·&nbsp; No credit card
      </p>
    </section>
  );
}
